import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';

import WellEditModal from './WellEditModal';
import { dispatchUpdateWell } from '../actions';
import { queryLookupWellsGQL } from '../graphql/getWellLookups';


const mapDispatchToProps = {
  dispatchUpdateWell,
};

const withRedux = connect(null, mapDispatchToProps);

const withNoWell = branch(
  (props) => {
    /* Checking for if initialValues has a well,
    will stop the call queryLookupLeasesGQL happening before the edit modal is open. */
    return props.initialValues === null;
  },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withNoWell,
  queryLookupWellsGQL,
);

export default enhance(WellEditModal);
